/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsreveal1Inputs */

const en_signupsreveal1 = /** @type {(inputs: Signupsreveal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show`)
};

const de_signupsreveal1 = /** @type {(inputs: Signupsreveal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeigen`)
};

/**
* | output |
* | --- |
* | "Show" |
*
* @param {Signupsreveal1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsreveal1 = /** @type {((inputs?: Signupsreveal1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsreveal1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsreveal1(inputs)
	return de_signupsreveal1(inputs)
});
export { signupsreveal1 as "signupsReveal" }